import React from "react";

interface SelfData {
    value: number,
    maxValue: number
}


export class TwsPercentLine extends React.Component<SelfData, SelfData> {
    state = {
        value: this.props.value,
        maxValue: this.props.maxValue
    }

    getLineWidth = () => {
        let width = this.props.value * 100 / this.props.maxValue;
        return width < 10 ? 10 : width;
    }

    getLineBackground = () => {
        return this.props.value >= 0 ? '#505E7F' : '#e95d3a';
    }

    render() {
        return <div className="tws-percent-line-container">
            <div className="tws-percent-line-line" style={{ width: `${this.getLineWidth()}%`, backgroundColor: `${this.getLineBackground()}` }}></div>
            <div className="tws-percent-line-value">{Math.round(this.props.value)}</div>
        </div>
    }
}